import { STATUS_TYPE } from '../../../enum';

export interface IInitialState {
  id?: string;
  actionType: string;
  actionId?: string;
  position: string;
  imageUrl: string;
  language: string;
  activeState: boolean;
  isAdvertiseBanner: boolean;
  isHomePageBottomImage: boolean;
  isCakeBanner: boolean;
  isFlowerBanner: boolean;
  isInviteEarnBanner: boolean;
  isEventServiceBanner: boolean;
}

export interface GetSlider {
  id: string;
}

export interface FindSlider {
  limit?: number;
  skip?: number;
  actionType?: string;
  language?: string;
  activeState?: boolean | string;
  bannerPlacement?: BannerPlacementValue | 'slider' | '';
}

export interface CreatePatchSlider {
  id?: string;
  actionType: string;
  actionId?: string;
  position: string;
  imageUrl: string;
  language: string;
  activeState: boolean;
  isAdvertiseBanner?: boolean;
  isHomePageBottomImage?: boolean;
  isCakeBanner?: boolean;
  isFlowerBanner?: boolean;
  isInviteEarnBanner?: boolean;
  isEventServiceBanner?: boolean;
}

export interface Slider {
  id: string;
  actionType: string;
  actionId: string;
  position: string;
  imageUrl: string;
  language: string;
  activeState: boolean;
  isAdvertiseBanner: boolean;
  isHomePageBottomImage: boolean;
  isCakeBanner: boolean;
  isFlowerBanner: boolean;
  isInviteEarnBanner: boolean;
  isEventServiceBanner: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: Slider[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};

export type BannerPlacementValue =
  | 'advertise'
  | 'homeBottom'
  | 'cake'
  | 'flower'
  | 'inviteEarn'
  | 'eventService'
  | '';

export const getBannerPlacement = (value: {
  isAdvertiseBanner?: boolean | string;
  isHomePageBottomImage?: boolean | string;
  isCakeBanner?: boolean | string;
  isFlowerBanner?: boolean | string;
  isInviteEarnBanner?: boolean | string;
  isEventServiceBanner?: boolean | string;
}): BannerPlacementValue => {
  const isTrue = (v: boolean | string | undefined) =>
    v === true || String(v) === 'true';

  if (isTrue(value.isAdvertiseBanner)) return 'advertise';
  if (isTrue(value.isHomePageBottomImage)) return 'homeBottom';
  if (isTrue(value.isCakeBanner)) return 'cake';
  if (isTrue(value.isFlowerBanner)) return 'flower';
  if (isTrue(value.isInviteEarnBanner)) return 'inviteEarn';
  if (isTrue(value.isEventServiceBanner)) return 'eventService';
  return '';
};

export const bannerPlacementFlags = (
  placement: BannerPlacementValue
): {
  isAdvertiseBanner: boolean;
  isHomePageBottomImage: boolean;
  isCakeBanner: boolean;
  isFlowerBanner: boolean;
  isInviteEarnBanner: boolean;
  isEventServiceBanner: boolean;
} => ({
  isAdvertiseBanner: placement === 'advertise',
  isHomePageBottomImage: placement === 'homeBottom',
  isCakeBanner: placement === 'cake',
  isFlowerBanner: placement === 'flower',
  isInviteEarnBanner: placement === 'inviteEarn',
  isEventServiceBanner: placement === 'eventService',
});

export const bannerPlacementLabel = (
  value: Parameters<typeof getBannerPlacement>[0]
): string => {
  switch (getBannerPlacement(value)) {
    case 'advertise':
      return 'Advertise Banner';
    case 'homeBottom':
      return 'Home Bottom Image';
    case 'cake':
      return 'Cake';
    case 'flower':
      return 'Flower';
    case 'inviteEarn':
      return 'Invite & Earn';
    case 'eventService':
      return 'Event Service';
    default:
      return 'Slider';
  }
};
